var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[(_vm.isAdmin)?_c('AdminLayout'):_c('UserLayout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }